import { render, staticRenderFns } from "./LinkNodeForUnit.vue?vue&type=template&id=2fe0b081&scoped=true&"
import script from "./LinkNodeForUnit.vue?vue&type=script&lang=js&"
export * from "./LinkNodeForUnit.vue?vue&type=script&lang=js&"
import style0 from "./LinkNodeForUnit.vue?vue&type=style&index=0&id=2fe0b081&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0b081",
  null
  
)

export default component.exports